import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import React, { memo } from 'react'

import { getDefaultZIndex } from '@affstore-ds/uikit'

import { queryClient } from './queryClient'
import { RestQueryClientProviderPropertiesInterface } from './RestQueryClientProvider.types'

export const RestQueryClientProvider = memo(({ children, withDevelopmentTools }: RestQueryClientProviderPropertiesInterface) => (
  <QueryClientProvider client={queryClient}>
    {children}
    {withDevelopmentTools && (
      <ReactQueryDevtools
        panelProps={{
          style: { zIndex: getDefaultZIndex('max') + 1 },
        }}
        initialIsOpen={false}
      />
    )}
  </QueryClientProvider>
))
RestQueryClientProvider.displayName = 'RestQueryClientProvider'
